import axios from "./axios";

const adminApi = {
  getDashboardStats: () => axios.get("/admin/dashboard/stats"),
  getTourStats: () => axios.get("/admin/tours/stats"),
  getBookingStats: () => axios.get("/admin/bookings/stats"),
};

export default adminApi;
